import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';

export default function defaultTemplate(TemplateComponent) {
	const Component = withNamespaces()(observer(TemplateComponent));
	Component.displayName = TemplateComponent.name;
	return Component;
}
